module.exports = __webpack_public_path__ + "img/ic_16_drilldown.20d6c0a3.svg";